// Utils
import { toLocaleString } from "../../../common-utils/string-utils/StringUtils";
import {
  filterLandmarksWhichHaveName,
  getCategorizedPoints,
} from "./LocationSummaryUtils";

function zeroFixedValue(value) {
  if (value === 0) {
    return value;
  }
  return toLocaleString(value);
}

function getAvgRealtyPrice(realtySociety) {
  if (realtySociety.count === 0) {
    return "--";
  }

  return (
    <>
      {`Rs. ${zeroFixedValue(realtySociety.mean)} per sq. ft.
        (Rs. ${zeroFixedValue(realtySociety.min)} - Rs.
        ${zeroFixedValue(realtySociety.max)} per sq. ft.)`}
    </>
  );
}

function getAvgCost(restaurants) {
  if (restaurants.counts === 0) {
    return "--";
  }

  return (
    <>
      {`Rs. ${zeroFixedValue(restaurants.mean)} (Rs. ${zeroFixedValue(
        restaurants.min
      )} - Rs. ${zeroFixedValue(restaurants.max)})`}
    </>
  );
}

export default function SocioEconomicIndicators({
  className = "",
  restaurants = {},
  realtySociety = {},
  points = [],
}) {
  const avgRealtyPrice = getAvgRealtyPrice(realtySociety);
  const avgCostOfTwoMeal = getAvgCost(restaurants);

  // filter points which have name and get points categorization
  const pointsWithName = filterLandmarksWhichHaveName(points);
  const categorizedPointsMap = getCategorizedPoints(pointsWithName);
  const { society = [] } = categorizedPointsMap;
  const apartmentComplexesCount = society.length || 0;

  return (
    <div className={`socia-economic-indicators ${className}`}>
      <p>
        <strong>Socio-economic indicators</strong>
      </p>
      <p>Apartment complexes: {zeroFixedValue(apartmentComplexesCount)} </p>
      <p>Average Realty Price: {avgRealtyPrice}</p>

      <p>Restaurants: {zeroFixedValue(restaurants.count)} </p>
      <p>Average Cost (For two persons): {avgCostOfTwoMeal}</p>
    </div>
  );
}
